import { injectable } from "inversify";
import { Controls } from "../shared/domain";

export interface KeyboardMappingService {
    getKeyboardMapping(userId: string): Controls;

    setControls(controls: Controls);
}

@injectable()
export class DefaultKeyboardMappingService implements KeyboardMappingService {
    private controls: Controls;

    constructor() {}

    public getKeyboardMapping(userId: string): Controls {
        return this.controls;
    }

    public setControls(controls: Controls) {
        this.controls = controls;
    }
}
